<script setup lang="ts">
/**
 * Логотип компании «ТКапитал», построенный на основе favicon.svg.
 * Используется в шапке (меню) и в подвале сайта.
 */
withDefaults(
  defineProps<{
    /** Размер логотипа (ширина/высота SVG), по умолчанию 34px. */
    size?: number;
    /** Показывать текстовую часть «ТКапитал» рядом с логотипом. */
    showText?: boolean;
  }>(),
  { size: 34, showText: false },
);
</script>

<template>
  <!-- Фрагмент из нескольких корней: родительский .logo-link выстраивает логотип и текст -->
  <svg
    data-name="ТКапитал"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    :width="size"
    :height="size"
    aria-hidden="true"
  >
    <rect x="8" width="83" height="96" rx="8" fill="#f8f7f3" />
    <path
      fill="#082137"
      d="M83,96H16a8,8,0,0,1-8-8V8a8,8,0,0,1,8-8H83a8,8,0,0,1,8,8V88A8,8,0,0,1,83,96ZM17,2a7,7,0,0,0-7,7V87a7,7,0,0,0,7,7H82a7,7,0,0,0,7-7V9a7,7,0,0,0-7-7Z"
    />
    <path
      fill="#f8f7f3"
      d="M19.14,15.14H80.57V40.71H61.86V66.14h5V82.43H32.71V66.14h5.15V40.71H19.14Z"
    />
    <path
      fill="#091e39"
      d="M21.86,17.86H78.31V38.29h-13V29h-6V69.29l4.78,0V79.59L36,79.57V69.29h5V29H34.43v9.29H21.86Z"
    />
  </svg>
  <span v-if="showText" class="logo-text">Капитал</span>
</template>
